package horcrux.frontend.common.views.collections.editcollectionmenu

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.analytics.ScreenViewEvent
import horcrux.frontend.common.views.collections.CollectionNavigatorMenuOption
import horcrux.frontend.common.views.collections.ImportButtonLabel
import react.FC
import react.PropsWithChildren

external interface EditPrivateCollectionMenuProps : PropsWithChildren {
    var globalAppState: GlobalAppState
}

val EditPrivateCollectionMenu = FC<EditPrivateCollectionMenuProps> { props ->
    val collectionNavigatorState = props.globalAppState.collectionNavigatorState
    val currentCollectionMetadataMaybe = props.globalAppState.currentCollectionMetadataMaybeState.get()

    EditCollectionMenu {
        this.globalAppState = props.globalAppState
        this.menuItemDataList = listOf(
            MenuItemData(CollectionNavigatorMenuOption.CREATE, alwaysVisible = true) { closeMenu ->
                collectionNavigatorState.showCreateCollectionDialogState.setTrue()
                closeMenu()
                props.globalAppState.analyticsClient.log(ScreenViewEvent.CREATE_COLLECTION)
            },
            MenuItemData(CollectionNavigatorMenuOption.EDIT_CHAT_PAGES, alwaysVisible = true) { closeMenu ->
                closeMenu()
                collectionNavigatorState.showManagePublicCollectionsState.setTrue()
            },
            MenuItemData(
                CollectionNavigatorMenuOption.COLLECTION_DETAILS,
                currentCollectionMetadataMaybe
            ) { closeMenu ->
                currentCollectionMetadataMaybe?.let {
                    collectionNavigatorState.showCollectionDetailsDialogState.setTrue()
                    closeMenu()
                    props.globalAppState.analyticsClient.log(ScreenViewEvent.COLLECTION_DETAILS)
                }
            },
            MenuItemData(CollectionNavigatorMenuOption.IMPORT_DOCUMENTS, currentCollectionMetadataMaybe) { closeMenu ->
                currentCollectionMetadataMaybe?.let {
                    collectionNavigatorState.showImportDocumentsDialog(ImportButtonLabel.IMPORT)
                    closeMenu()
                    props.globalAppState.analyticsClient.log(ScreenViewEvent.IMPORT_DOCUMENTS)
                }
            },
            MenuItemData(CollectionNavigatorMenuOption.EDIT_NAME, currentCollectionMetadataMaybe) { closeMenu ->
                currentCollectionMetadataMaybe?.let {
                    collectionNavigatorState.showEditNameDialogState.setTrue()
                    closeMenu()
                    props.globalAppState.analyticsClient.log(ScreenViewEvent.EDIT_COLLECTION_NAME)
                }
            },
            MenuItemData(CollectionNavigatorMenuOption.DELETE, currentCollectionMetadataMaybe) { closeMenu ->
                currentCollectionMetadataMaybe?.let {
                    collectionNavigatorState.showDeleteCollectionDialogState.setTrue()
                    closeMenu()
                    props.globalAppState.analyticsClient.log(ScreenViewEvent.DELETE_COLLECTION)
                }
            },
        )
    }
}

